import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title="页面走丢了 — 瓜乐圈"
        description="没有找到你要访问的页面，回到瓜乐圈首页继续轻松吃瓜。"
        path={location.pathname}
        robots="noindex, follow"
      />
      <Navbar />
      <main className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          这个瓜好像走丢了
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面可能已经调整了位置。不确定从哪里开始的话，回首页随便挑一个栏目看看也不错。
        </p>
        <p className="mt-3 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            回到首页
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            看看常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}